import Service from './Service';

export default class ProductClassService extends Service {
    constructor() {
        super();
        this.baseURL = 'product/productclass';
    }

}